<template>
  
  <div class="flex flex-col items-center bg-checkout-mainbg border-r border-checkout-mainborder pb-20 mx-auto"><!--WRAPPER-->
  
   <h1 v-if="detailsEntered==0" class="chH1 mt-4" id="1">Kies je opslagruimte</h1>
   <p v-if="detailsEntered==0" class="chP mt-3">Betaal alleen voor wat je gebruikt. Gratis upgraden en downgraden.</p>
   
   
   <div v-if="detailsEntered==0" class="grid grid-cols-2 gap-4 items-center"><!--Offers in current category -->
      <button v-for="(offer,j) in offers" :key="j"
       @click="selectSize(offer.size)"
       class="relative w-60 h-28 mt-4 border border-checkout-mainborder rounded-lg mx-auto md:mx-0 hover:shadow-2xl"
       v-bind:class="{'bg-gamma-blue':selectedSize==offer.size}"><!--SINGLE SIZE BOX-->
        <h3 class=" mt-[14px]"
        v-bind:class="[{'text-white':selectedSize==offer.size},{'text-gamma-blue':selectedSize!=offer.size}]">{{offer.size}}m<sup>3</sup></h3>
        <p class="mt-[4px]"
        v-bind:class="{'text-white':selectedSize==offer.size}">{{offer.type}}</p>
        <p v-if="detailsEntered || selectedCommitment==12" class="mt-[4px]"
        v-bind:class="{'text-white':selectedSize==offer.size}"> vanaf € {{calculateDiscountPrice(offer.price,selectedCommitment)}} p/m</p>
        <p v-else class="mt-[4px]"
        v-bind:class="{'text-white':selectedSize==offer.size}"> vanaf € ?? p/m</p>       
      </button><!--END SINGLE SIZE BOX-->

      
   
    </div><!--END Offers in current category -->
    
      
    <h1 v-if="detailsEntered==0" class="chH1 mt-4" id="2">Kies je huurperiode</h1>
    <p v-if="detailsEntered==0" class="chP mt-2">Na de gekozen periode maandelijks verlengd.</p>
    

    <div v-if="detailsEntered==0" class="grid grid-cols-2 gap-4 mt-4"><!-- Commitment -->
      <button v-for="(commitment,i) in commitments" :key="i" @click="selectCommitment(commitment.period)"
       class="w-60 h-28 mt-4 border border-checkout-mainborder rounded-lg mx-auto md:mx-0"
       v-bind:class="{'bg-gamma-blue':selectedCommitment==commitment.period}"><!--SINGLE COMMITMENT BOX-->
        <h3 class="mt-[14px]"
        v-bind:class="[{'text-white':selectedCommitment==commitment.period},{'text-gamma-blue':selectedCommitment!=commitment.period}]">{{commitment.title}}</h3>
        <p class="chKorting bg-checkout-greenlight p-1 rounded-xl w-[100px] mx-auto mt-[10px]"
        v-bind:class="{'text-white':selectedCommitment==commitment.period}">{{commitment.discount}} <span v-if="i!=0">Korting</span></p>
        <p v-if="i!=0" class="chPS mt-[3px]"
        v-bind:class="{'text-white':selectedCommitment==commitment.period}">Beste prijs garantie!</p>     
      </button><!--END SINGLE COMMITMENT BOX-->   
    </div><!--END Commitment -->
    <div v-if="detailsEntered==0" class="flex flex-col">
      <h1  class="mt-4" id="3">Kies je region</h1>
      <select v-model="travelCost" @change="changeTravelCosts()" class="inpt mt-2">  
        <option v-for="(tc,i) in travelCosts" :key="i" :value="i">{{tc.name}}</option>
      </select>
    </div>  

    <h1 v-if="detailsEntered==0" class="mt-4" id="3">Kies je servicepakket</h1>
    <p v-if="detailsEntered==0" class="mt-2">Van self-service tot full service. Kies wat jij wilt!</p>


    <div v-if="detailsEntered==0" class="flex flex-col"><!-- Service plans -->      

      <div class="flex flex-col w-full mt-5 border border-checkout-mainborder rounded-lg"
      v-bind:class="{'bg-checkout-light border-checkout-primary':checkSPone}"><!--SINGLE SP BOX-->
       <div class="flex justify-between items-center py-6">
          <div class="flex items-center">
            <button v-if="spanSPone" @click="spanSPone=false" class="ml-1 md:ml-9 mr-1 md:mr-5"><img src="@/assets/images/hideArrowGamma.svg" class=""></button>
            <button v-else @click="spanSPone=true" class="ml-1 md:ml-9 mr-1 md:mr-5"><img src="@/assets/images/dropArrowGamma.svg" class=""></button>
              <div class="hidden md:flex items-center">
                <h3 class="mr-3">Basis-service: </h3>
                <p class="mt-0.5">ophalen & bezorgen</p>
              </div>
              <div class="flex flex-col md:hidden">
                <h3 class="text-sm font-bold">Basis-service:</h3>
                <p class="text-xs ">ophalen & bezorgen</p>
              </div>  
          </div>
          <div v-if="checkSPone" class="flex mr-6">
            
            <img src="@/assets/images/check-square.svg" class="">
          </div>
          <button v-if="!checkSPone" @click="chooseBasic()" class="flex mr-6">
            <img src="@/assets/images/square.svg" class="">
          </button>
        </div>   
        <div v-if="spanSPone" class="relative w-min flex flex-col border-t bg-checkout-mainbg border-checkout-mainborder"><!-- Span section -->
          <span class="absolute bottom-5 -right-40">€{{travelTotal}}</span>
          <h4 class="pl-5">Inclusief</h4>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="">1 chauffeur</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="">Basis beschermingspakket</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="">Opslagunit(s) indelen</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="">Opslagunit(s) vervoer klaar maken</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="">Professioneel vervoer</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <p class="w-96">
              We delen jouw opslagunit(s) in, voegen een basis beschermingspakket toe en maken de opslagunit(s) vervoer klaar.  Wij vervoeren de opslagunit(s), sealen ze in en slaan ze veilig en geconditioneerde op.
              Je spullen blijven ten allen tijden in jouw persoonlijke opslagunit(s).
            </p>
          </div>  

          <div class="w-max flex mt-2 pl-5">
            <p class="w-96 italic"> Dit tarief geldt ook voor het terugbrengen in dezelfde postcode.</p>
          </div>  

          <div class="w-max flex mt-2 pl-5">
            <p class="w-96 italic">* Ophalen en terugbrengen zijn gratis in de Randstad vanaf 3 maanden ovk. Vraag naar de voorwaarden.</p>
          </div>   
             


        </div><!-- END span section -->    
    
      </div><!--END SINGLE SP BOX-->

      <div class="flex flex-col w-full mt-5 border border-checkout-mainborder rounded-lg"
      v-bind:class="{'bg-checkout-light border-checkout-primary':checkSPtwo}"><!--SINGLE SP BOX-->
       <div class="flex justify-between items-center py-6">
          <div class="flex items-center">
            <button v-if="spanSPtwo" @click="spanSPtwo=false" class="ml-1 md:ml-9 mr-1 md:mr-5"><img src="@/assets/images/hideArrowGamma.svg" class=""></button>
            <button v-else @click="spanSPtwo=true" class="ml-1 md:ml-9 mr-1 md:mr-5"><img src="@/assets/images/dropArrowGamma.svg" class=""></button>
              <div class="hidden md:flex items-center">
                <h3 class="mr-3">Premium service:</h3>
                <p class="mt-0.5">ophalen, sjouwen & bezorgen</p>
              </div>
              <div class="flex flex-col md:hidden">
                <h3 class="text-sm font-bold">Premium service:</h3>
                <p class="text-xs">ophalen, sjouwen & bezorgen</p>
              </div>
          </div>
          <div v-if="checkSPtwo" class="flex mr-6">
            <img src="@/assets/images/check-square.svg" class="">
          </div>
          <button v-if="!checkSPtwo" @click="choosePremium()" class="flex mr-6">
            <img src="@/assets/images/square.svg" class="">
          </button>
        </div>   
        <div v-if="spanSPtwo" class="relative w-min flex flex-col border-t bg-checkout-mainbg border-checkout-mainborder"><!-- Span section -->
          <span class="absolute bottom-2 -right-40 chKies">€{{currentOffer.premium}} + €{{travelTotal}} (travel costs) </span>
          
          <h4 class="pl-5">Inclusief:</h4>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="chSPES">2 verhuishulpen</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="chSPES">Basis beschermingspakket</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1]">
            <span class="chSPES">Opslagunit(s) indelen</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="chSPES">Opslagunit(s) vervoer klaar maken</span>
          </div>
          <div class="w-max flex mt-2 pl-5">
            <img src="@/assets/images/gamma-check.svg" class="mr-1">
            <span class="chSPES">Professioneel vervoer</span>
          </div> 

          <div class="w-max flex mt-2 pl-5">
            <p class="w-96 italic"> 
              Wij sjouwen al je spullen, We delen jouw opslagunit(s) in, voegen een basis beschermingspakket toe en maken de opslagunit(s) vervoer klaar.  Wij vervoeren de opslagunit(s), sealen ze in en slaan ze veilig en geconditioneerde op.
              Je spullen blijven ten allen tijden in jouw persoonlijke opslagunit(s).</p>
          </div>

          <div class="w-max flex mt-2 pl-5">
            <p class="w-96 italic"> 
              Dit tarief geldt ook voor het terugbrengen in dezelfde postcode.</p>
          </div>


        </div><!-- END span section -->    
    
      </div><!--END SINGLE SP BOX-->

      

      
      
   
    </div><!--END Service plans -->

    <div v-if="detailsEntered==0" class="bg-gamma-green border-2 border-white rounded-3xl flex justify-center p-2 mt-6 hover:shadow-2xl">
      
      <button @click="changeDetailsEntered(1)"><p class="text-white md:text-sm lg:text-lg mt-1 ">Next stap</p></button>
    </div>
    
    
    
    
    
      
      

       <div v-if="detailsEntered==1" class="flex flex-col items-center w-1/2 mt-[16px]"><!--SINGLE SP BOX-->
        <h3 class="chH3 mt-[32px] pl-[32px]">Het ophaaladres</h3>
        
        

        <div class="flex flex-col justify-center mt-2 h-24">
          <p class="text-sm font-bold">Ophaaladres</p>
          <input v-model="address" placeholder="Second street 22" v-bind:class="[{ 'inpt': !ophalError }, {'inptError': ophalError }]">
          <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="ophalError"><br>{{ophalError}}</p>
        </div>
        
        <div class="flex flex-col justify-center mt-2 h-24">
          <p class="text-sm font-bold">Postcode</p>
          <input ref="zip" v-model="zip" :readonly="$store.state.quotes.length>0" placeholder='1234 AB' v-bind:class="[{ 'inpt': !zipError }, {'inptError': zipError }]">
          <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="zipError"><br><br>{{zipError}}</p>
        </div>


        <div class="flex flex-col justify-center mt-2 h-24">
          <p class="text-sm font-bold">Stad</p>
          <input  v-model="city" :readonly="$store.state.quotes.length>0" placeholder='Amsterdam' v-bind:class="[{ 'inpt': !cityError }, {'inptError': cityError }]">
          <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="cityError"><br><br>{{cityError}}</p>
        </div>

        <div class="flex flex-col justify-center mt-2 h-24">
          <p class="text-sm font-bold">Voornaam</p>
          <input v-model="fullName" placeholder='Jane' v-bind:class="[{ 'inpt': !nameError }, {'inptError': nameError }]">
          <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="nameError"><br>{{nameError}}</p>
        </div>

        <div class="flex flex-col justify-center mt-2 h-24">
          <p class="text-sm font-bold">Achternaam</p>
          <input v-model="lname" placeholder='Doe' v-bind:class="[{ 'inpt': !lnameError }, {'inptError': lnameError }]">
          <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="lnameError"><br>{{lnameError}}</p>
        </div>

       <div class="flex flex-col justify-center mt-2 h-24">
          <p class="text-sm font-bold">E-mailadres</p>
          <input v-model="email" placeholder='voorbeeld@gmail.com' v-bind:class="[{ 'inpt': !emailError }, {'inptError': emailError }]">
          <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="emailError"><br>{{emailError}}</p>
        </div>
        <div class="flex flex-col justify-center mt-2 h-24">
          <p class="text-sm font-bold">Telefoonnummer</p>
          <input v-model="phone" placeholder='telefoonnummer' v-bind:class="[{ 'inpt': !phoneError }, {'inptError': phoneError }]">
          <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="phoneError"><br>{{phoneError}}</p>
        </div>
        <div v-if="finError" class="pl-[32px] text-red-500">
          {{finError}}
        </div>
        
        <div v-if="detailsEntered" class="bg-gamma-green w-1/2 mx-auto border-2 border-white rounded-3xl flex justify-center py-2 mt-6 hover:shadow-2xl">
      <img src="@/assets/images/calculatorWhite.png" alt="" class="w-5 h-5 my-auto" />
      <button @click="submit()"><p class="text-white md:text-sm lg:text-lg mt-1">Ontvang je offerte</p></button>
    </div> 
                  
       </div><!--END SINGLE SP BOX-->
      
    <div v-if="detailsEntered==2" class="flex flex-col w-1/2   border rounded-lg border-checkout-mainborder mt-16 overflow-hidden"><!-- QUOTE BOX-->
        <h2 class="chH2 m-6">Overzicht</h2>
        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/opslag-gamma.svg" class="mr-5">
            <span class="chSpan">Opslagruimte</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{submitData.storage_size}} m<sup>3</sup></span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->   

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/commitment-gamma.svg" class="mr-5">
            <span class="chSpan">Huurperiode</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getCommitmentTitle(submitData.commitment)}}</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->

         

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/small-truck-gamma.svg" class="mr-5">
            <span class="chSpan">Servicepakket</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getPlan()}} (€{{getPlanPrice()}},00)</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->

        

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/clock.svg" class="mr-5">
            <!--<span class="chSpan">{{getPrefDate()}}</span>-->
            <span class="chSpan">Ophaaldatum</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getPrefMoment()}} (€{{getPrefMomentPrice()}},00)</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->  

        <div class="flex justify-between py-5 px-6 bg-checkout-light border-t border-checkout-pborder"><!-- TOTAL PRICE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/shopping-bag.svg" class="mr-5">
            <span class="chStrongSpan">Eenmalig</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chStrongSpan mr-1">€ {{getPlanPrice()*1 + travelTotal*1}}</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END TOTAL PRICE-->     

        <div class="flex justify-between py-5 px-6 bg-checkout-light border-t border-checkout-pborder"><!-- PER MONTH PRICE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/repeat.svg" class="mr-5">
            <span class="chStrongSpan">Maandelijks</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chStrongSpan mr-1">€{{calculateDiscount(submitData.commitment)}},00</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END PER MONTH PRICE-->        
      
    </div><!-- END QUOTE BOX--> 
    

    <h1  v-if="detailsEntered==2" class="chH1 mt-10" id="5">Kies jouw ophaaldatum</h1>
    <p  v-if="detailsEntered==2" class="chP mt-[12px]">Binnen 24u? Bel ons op 085- 30 30 880.</p>

    
      
      <div v-if="detailsEntered==2" class="flex flex-col w-1/2">          
        
        <div class="flex flex-col items-start border border-checkout-mainborder rounded-lg overflow-hidden"><!--DATE BOX-->
          <h3 class="mt-8 pl-8">Ophaaldatum</h3>
          <div class="flex">
            <div class="flex flex-col mt-6 pl-8 pr-4 w-full"><!-- date input -->
              <p class="text-sm font-bold">Kies je ophaaldatum</p>
              <input type="date" v-model="pickupDate" class="inpt" />          
            </div><!-- END date input -->

            

            <div class="flex flex-col justify-center mt-2 h-24 pl-8">
                <p class="text-sm font-bold">Voorkeursmoment</p>
                <select v-model="prefMoment" class="inpt">
                  <option value="0">Dagplanning 08:00 - 19:00 (gratis)</option>
                  <option value="1">Ochtendvak 08:00 - 12:00 (+ € 20)</option>
                  <option value="2">Middagvak 12:00 - 16:00 (+ € 20)</option>
                  <option value="3">DagStart 08:00 - 10:00 (+ € 35)</option>
                  <option value="4">Weekend (+ € 50)</option>
                </select>
              </div>
          </div>    
          
          

          <div class="border-t border-checkout-pborder bg-checkout-light px-6 mt-6 pb-5 w-full"><!-- bottom box -->
            <p class="mt-4">De gereserveerde ophaaldatum</p>
            <p class="mt-2">{{getDayName(pickupDate,"nl-NL")}} {{getDay(pickupDate)}} {{getMonthName(pickupDate,"nl-NL")}} {{getPrefTime(prefMoment)}}</p>

          </div><!--END bottom box -->          
        </div><!--END DATE BOX-->
        <div class="flex flex-col items-start mt-4 mr-8 border border-checkout-mainborder rounded-lg overflow-hidden"><!--DATE BOX-->
          <h3 class="mt-8 pl-8">Zakelijk huren?</h3>
          <p class="mt-2 pl-8">Vul je bedrijfsnaam in</p>
          <div class="flex  mt-6 pl-8 pr-4 w-full"><!-- name input -->
            
            
            <input v-model="klantBox" type="checkbox" @change="changeKlant()" class="mr-1.5">
            <span class="chL">Zakelijke klant</span>  
            
          </div>  

          <div class="flex flex-col justify-center mt-2 h-24 pl-8 mb-3">
            <p class="text-sm font-bold">Bedrijfsnaam</p>
            <input ref="zip" v-model="companyName" :disabled="klantType=='b2c'" v-bind:class="[{ 'inpt': !companyNameError }, {'inptError': companyNameError }]">
            <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="companyNameError"><br><br>{{companyNameError}}</p>
          </div>  
               
        </div><!-- END name input -->
      </div> 

      <div v-if="detailsEntered==2" class="w-1/2 flex flex-col mt-5 border border-checkout-mainborder rounded-lg"><!--SINGLE SP BOX-->
       <div class="flex justify-between items-center py-5">
          <div class="flex items-center">
              <h3 class="chKies mr-2 ml-2">Meer informatie:</h3>
          </div>
          <button v-if="spanSPone" @click="spanSPone=false" class="p-2"><img src="@/assets/images/hideArrowGamma.svg" class=""></button>
          <button v-else @click="spanSPone=true" class="p-2"><img src="@/assets/images/dropArrowGamma.svg" class=""></button>
          
        </div>   
        <div class="flex flex-col border-t bg-checkout-mainbg border-checkout-mainborder p-2"><!-- Span section -->
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
              Je maakt de reservering compleet en ontvangt de eerste factuur.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Na betaling kun je de voorkeursdatum voor de ophaalafspraak via de uitnodiging bevestigen.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Een dag voor ophaalafspraak ontvang je om uiterlijk 19:00 een ETA mail. Op de dag zelf belt de chauffeur vlak voor aankomst nog.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             We halen je spullen volgens de gedane boeking op. Zijn het iets meer spullen dan proberen we het mee te nemen. Blijkt het toch minder te zijn dan kun je een downgrade verzoek doen.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Bij de ophaal afspraak voegen we een basisbeschermingspakket toe, laden je spullen efficiënt in de opslagunits en maken de opslagunits vervoer klaar.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             We vervoeren de opslagunits professioneel en slaan ze geconditioneerd op totdat jij ze weer nodig hebt.
            </p>  
          </div>
          <div v-if="spanSPone" class="flex items-start mt-2">
            <img src="@/assets/images/gamma-check.svg" class="py-2 mr-1">
            <p class="mt-1">
             Wil je je spullen weer terug ontvangen? Stuur een mail naar klantenservice@inboxstorage.eu, ontvang een uitnodiging en plan je terugbrengafsrpaak zelf in; simpel!
            </p>  
          </div>

          <div class="flex flex-col w-full mt-4 p-2 border border-checkout-mainborder rounded-lg"
            v-bind:class="{'bg-checkout-light border-checkout-primary':agreeOne}"><!--SINGLE ES BOX-->
            <div class="flex justify-between items-center py-[24px]">
                <div class="flex items-center">
                    <div class="flex items-center ml-[24px]">
                      <button @click="agreeOne=!agreeOne" class="w-10 h-10  mr-2">
                        <img v-if="agreeOne" src="@/assets/images/check-square.svg" class="w-10 h-10">
                        <img v-else src="@/assets/images/square.svg" class="w-10 h-10">
                      </button>
                    </div>              
                    <h3 class="chKies mr-[12px] ml-[37px]">Ik accepteer de 
                      <span class="border-b border-gamma-blue">
                        <a href="https://inboxstorage.eu/pdf/Algemene-Voorwaarden-Inboxstorage-v1.pdf" target="_blank">algemene voorwaarden</a>
                      </span>
                    </h3>
                </div>
                
              </div>        
          </div><!--END SINGLE ES BOX-->
          <div class="flex flex-col w-full mt-4 p-2 border border-checkout-mainborder rounded-lg"
            v-bind:class="{'bg-checkout-light border-checkout-primary':agreeTwo}"><!--SINGLE ES BOX-->
            <div class="flex justify-between items-center py-[24px]">
                <div class="flex items-center">
                    <div class="flex items-center ml-[24px]">
                      <button @click="agreeTwo=!agreeTwo" class="w-10 h-10 mr-2">
                        <img v-if="agreeTwo" src="@/assets/images/check-square.svg" class="w-10 h-10">
                        <img v-else src="@/assets/images/square.svg" class="w-10 h-10">
                      </button>
                    </div>              
                    <h3 class="chKies mr-[12px] ml-[37px]">Ik in – en verpak mijn spullen volgens de 
                      <span class="border-b border-gamma-blue">
                        <a href="https://inboxstorage.eu/pdf/Inpak-instructies-2.3.pdf" target="_blank">inpakinstructies</a>
                      </span>
                    </h3>
                </div>
                
              </div>        
          </div><!--END SINGLE ES BOX-->
          <div  id="1" class="flex flex-col w-full  mt-4 p-2 border border-checkout-mainborder rounded-lg mb-2"
            v-bind:class="{'bg-checkout-light border-checkout-primary':agreeThree}"><!--SINGLE ES BOX-->
            <div class="flex justify-between items-center py-[24px]">
                <div class="flex items-center">
                    <div class="flex items-center ml-[24px]">
                      <button @click="agreeThree=!agreeThree" class="w-10 h-10 mr-2">
                        <img v-if="agreeThree" src="@/assets/images/check-square.svg" class="w-10 h-10">
                        <img v-else src="@/assets/images/square.svg" class="w-10 h-10">
                      </button>
                    </div>              
                    <h3 class="chKies mr-[12px] ml-[37px]">Annuleren van de boeking is 48 uur na de boeking kosteloos. Daarna is het herroepingsrecht niet van toepassing.</h3>
                </div>
                
              </div> 
             
          </div><!--END SINGLE ES BOX-->
          
          <div v-if="error" class="text-red-500">
            {{error}}
          </div>
            


        </div><!-- END span section -->    
    
      </div><!--END SINGLE SP BOX-->  

      <div v-if="detailsEntered==2" class="bg-gamma-green border-2 border-white rounded-3xl flex justify-center py-2 mt-6">
      
      <button @click="submit()"><p class="text-white md:text-sm lg:text-lg mt-1">Reservering bevestigen</p></button>
    </div>
      

       
      
   
    
   

    
    
    <div v-if="animation"
          class="w-[50rem] border-2 border-white rounded-xl mx-auto"
        ><!-- Calculation animation -->
          <img src="@/assets/images/truckBlack.svg" alt="" class="an" /> 
          <p class="text-3xl text-center font-bold">Houd je vast! We zijn voor je aan het rekenen.</p>
        </div><!-- END Calculation animation --> 

    
  </div><!--END WRAPPER-->
  <!--<Rightbar class=""/>-->
  
</template>

<script>
import axios from 'axios'
import {mapState, mapMutations, mapActions} from 'vuex'
import Rightbar from '../components/Rightbar.vue'
export default {
  components: { Rightbar },
  data() {
    return {
      plan: 'basic',
      animation: false,
      phoneCode: '+31',
  
      spanSPone: false,
      spanSPtwo: false,
      spanSPthree: false,
      checkSPone:false,
      checkSPtwo: false,
      checkSPthree:false,

      totalES: 0,
      spanES: false,
      totalESPrice: 0,

      spanDriverHelp:false,
      checkDriverHelp:false,

      spanPakMaterial:false,
      checkPakMaterial:false,

      spanVerpakHulp:false,
      checkVerpakHulp:false,

      spanDemontage:false,
      checkDemontage:false,

      spanVerhuislift:false,
      checkVerhuislift:false,

      spanTussenStop:false,
      checkTussenStop:false,

      spanFilter:false,

      selectedCommitment: '12',
      selectedSize: '',

      prefMoment: 0,
      pickupDate: '',

      klantBox: false,
      klantType: 'b2c',

      companyName: '',

      address: '',
      zip: '',
      fullName: '',
      lname: '',
      lnameError: '',
      email: '',
      phone: '',
      city: '',

      link: '',
      finError: '',
      travel: '',
      refreshedOnce: false,

      travelCost: 0,
      travelTotal: 0,
      agreeOne: false,
      agreeTwo: false,
      agreeThree: false,
    }
  },//END data()
  computed: {
    ...mapState(['categoryData','commitments','categoriesAll','offers','submitData','currentOffer','controlLink','ip','detailsEntered','currentSizeData','travelCosts'])
  },
  methods: {
    ...mapMutations(['changeCheckoutSubmit','changeCheckoutData','editSize','changeSubmitData','editCategory','changeLink','changeDetailsEntered','changeCurrentSizeData']),
    calculateDiscountPrice(price,commitment){
      if (commitment < 3) 
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.90)
      else if (commitment < 12)
        return Math.round(price * 0.75)
      else if (commitment >= 12)
        return Math.round(price * 0.60)   

    },
    calculateDiscount(commitment){
      let price = this.currentOffer.price
    if (commitment < 3) 
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.90)
      else if (commitment < 12)
        return Math.round(price * 0.75)
      else if (commitment >= 12)
        return Math.round(price * 0.60)     
    },
    changeKlant(){
     if(this.klantBox)
      this.klantType='b2b'
     else{
      this.klantType='b2c'
      this.companyName=''
     } 
    },
    chooseBasic(){
      this.checkSPone=true
      this.checkSPtwo=false
      this.changeSubmitData({item:'plan',new:'Inbox Basic'})
      this.changeSubmitData({item:'planPrice',new:0})
    },
    choosePremium(){
      this.checkSPone=false
      this.checkSPtwo=true
      this.changeSubmitData({item:'plan',new:'Inbox Premium'})
      this.changeSubmitData({item:'planPrice',new:this.currentOffer.premium})
    },
    selectCommitment(period){
      this.selectedCommitment = period
      this.changeSubmitData({item:'commitment',new:this.selectedCommitment})
      this.changeTravelCosts()

    },
    async selectSize(size){
     this.selectedSize=size
     this.editSize(size)
     this.changeSubmitData({item:'storage_size',new:this.selectedSize})
     if (this.checkSPtwo)
      this.choosePremium()
     else
      this.chooseBasic()

      await axios.get(`https://api-production.inboxstorage.eu/api/v1/control/size/getpost/${size}`).then((response)=>{     
          let data = response.data[0]  
          this.changeCurrentSizeData({item:'size',new:size})
          this.changeCurrentSizeData({item:'lineOne',new:data.lineOne})
          this.changeCurrentSizeData({item:'lineTwo',new:data.lineTwo})
          this.changeCurrentSizeData({item:'lineThree',new:data.lineThree})
          this.changeCurrentSizeData({item:'lineFour',new:data.lineFour})
          this.changeCurrentSizeData({item:'paragraphOne',new:data.body})
          this.changeCurrentSizeData({item:'paragraphTwo',new:data.bodyMin})                   
        }).catch(error => {
          
          console.log(error)
        });
       
    },
    changeTravelCosts(){
      console.log(this.travelCost)
      if(this.selectedCommitment == 1)
       this.travelTotal = this.travelCosts[this.travelCost].one
      if(this.selectedCommitment == 3)
       this.travelTotal = this.travelCosts[this.travelCost].three
      if(this.selectedCommitment == 6)
       this.travelTotal = this.travelCosts[this.travelCost].six
      if(this.selectedCommitment == 12)
       this.travelTotal = this.travelCosts[this.travelCost].twelve   

       

    },
    selectCategory(cat){
     this.editCategory(cat.i)
     this.selectSize(cat.start) 
     this.spanFilter = false
    },

    setDriverHelp(){
     this.checkDriverHelp=!this.checkDriverHelp
     if(this.checkDriverHelp){
      this.totalES++
      this.totalESPrice += 50
     }
     else{
      this.totalES--
      this.totalESPrice -=50
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})
    },
    setPakMaterial(){
      this.checkPakMaterial=!this.checkPakMaterial
     if(this.checkPakMaterial){
      this.totalES++
     }
     else{
      this.totalES--
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
    },
    setVerpakHulp(){
      this.checkVerpakHulp=!this.checkVerpakHulp
     if(this.checkVerpakHulp){
      this.totalES++
      this.totalESPrice += 160
     }
     else{
      this.totalES--
      this.totalESPrice -=160
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})

    },
    setDemontage(){
       this.checkDemontage=!this.checkDemontage
     if(this.checkDemontage){
      this.totalES++
      this.totalESPrice += 130
     }
     else{
      this.totalES--
      this.totalESPrice -=130
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})

    },
    setVerhuislift(){
        this.checkVerhuislift=!this.checkVerhuislift
     if(this.checkVerhuislift){
      this.totalES++
      this.totalESPrice += 180
     }
     else{
      this.totalES--
      this.totalESPrice -=180
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})

    },
    setTussenStop(){
         this.checkTussenStop=!this.checkTussenStop
     if(this.checkTussenStop){
      this.totalES++
      this.totalESPrice += 50
     }
     else{
      this.totalES--
      this.totalESPrice -=50
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})
    },
    getDayName(dateStr, locale){
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { weekday: 'long' });        
    },
    getMonthName(dateStr, locale){
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { month: 'long' });        
    },
    getDay(dateStr){
      var date = new Date(dateStr);
      return date.getDate();        
    },
    getPrefTime(moment){
      if(moment==0)
        return "08:00 - 19:00";
      if(moment==1)
        return "08:00 - 12:00";
      if(moment==2)
        return "12:00 - 16:00";
      if(moment==3)
        return "08:00 - 10:00";
      if(moment==4)
        return "Weekend";
    },
    sevenDays(){
      const date = new Date();
      date.setDate(date.getDate() + 7);
      var formatted_date = date.toJSON().slice(0,10);
      return formatted_date
    },
    setPrefMoment(moment){
      if(moment==0){
        this.changeSubmitData({item:'prefMoment',new:'Dagplanning'})
        this.changeSubmitData({item:'prefMomentPrice',new:0})
      }  
      if(moment==1){
        this.changeSubmitData({item:'prefMoment',new:'Ochtendvak'})
        this.changeSubmitData({item:'prefMomentPrice',new:20})
      }  
      if(moment==2){
        this.changeSubmitData({item:'prefMoment',new:'Middagvak'})
        this.changeSubmitData({item:'prefMomentPrice',new:20})
      }  
      if(moment==3){
        this.changeSubmitData({item:'prefMoment',new:'DagStart'})
        this.changeSubmitData({item:'prefMomentPrice',new:35})
      }  
      if(moment==4){
        this.changeSubmitData({item:'prefMoment',new:'Weekend'})
        this.changeSubmitData({item:'prefMomentPrice',new:50})
      }            
    },


    async submit(){
      this.finError = ""
      if(!this.phone){
        this.finError = "Phone number is required"
        return;
      }
      if(!this.address){
        this.finError = "Address is required"
        return;
      }
      if(!this.lname){
        this.finError = "Last name is required"
        return;
      }
      
      if (this.klantType == 'b2b' && !this.companyName){
        this.finError = "Company name required for Business client type"
        return;
      }
      this.changeSubmitData({item:'phone_number',new:this.phone})
       this.changeSubmitData({item:'oldPhone',new:this.phone})
      this.animation=true

        
       

        //HS STUFF
        let hubName = this.fullName
        let hubLname = this.lname
        let hubMail = this.email
        let hubPhone = this.phone
        let hubZip = this.zip
        let hubCity = this.city
        let hubCommitment = this.submitData.commitment
        let hubSize = this.submitData.storage_size
        let hubWhen = this.submitData.wanneer_opslagruimte_nodig
        let hubAddress = this.address
        let hubServiceType = this.submitData.plan
        let hubserviceplanprice = this.submitData.planPrice
        
        let hubDatum = this.pickupDate
        let hubMoment = this.prefMoment
        let hubCtype = this.klantType
        let hubBedrif = this.companyName

        let hubPrice = this.calculateDiscount(hubCommitment)
        let hubLink = this.link
        
        
        let hubQuotePriceOne = this.calculateDiscount(1)
        let hubQuotePriceTwo = this.calculateDiscount(3)
        let hubQuotePriceThree = this.calculateDiscount(6)
        let hubQuotePriceFour = this.calculateDiscount(12)
        let hubSquare_meters = this.currentOffer.sizeSquare *1
        let hubBasic = this.travel
        let hubPremium = (this.currentOffer.premium *1 + (this.travel/1.4*1.9)).toFixed(2)
        let hubspotFields = [
            
            {
                'name' : 'firstname',
                'value' : hubName,
            },
            {
                'name' : 'lastname',
                'value' : hubLname,
            },
            {
                'name' : 'email',
                'value' : hubMail,
            },
            {
                'name' : 'zip',
                'value' : hubZip,
            },
            
            {
                'name' : 'aantal_kuub',
                'value' : hubSize,
            },
            {
                'name' : 'when_storage_required02',
                'value' : hubWhen,
            },
            {
                'name' : 'city',
                'value' : hubCity,
            },
            {
                'name' : 'address',
                'value' : hubAddress,
            },
            {
                'name' : 'serviceType',
                'value' : hubServiceType,
            },
            {
                'name' : 'serviceplanprice',
                'value' : hubserviceplanprice,
            },

            {
                'name' : 'travelCosts',
                'value' : this.travelTotal,
            },            
            
            {
                'name' : 'phone',
                'value' : hubPhone,
            },
            {
                'name' : 'commitment',
                'value' : hubCommitment,
            },          
            {
                'name' : 'pref_date',
                'value' : hubDatum,
            },
            {
                'name' : 'voorkeursmoment',
                'value' : hubMoment,
            },
            {
                'name' : 'klanttype',
                'value' : hubCtype,
            },
            {
                'name' : 'company',
                'value' : hubBedrif,
            },
            
        ];
        let data = {}
        data['context']={
          'pageUri': 'https://inboxstorage.eu/commitment',
          'pageName': 'Commitment',
          
        }
        data['fields']=hubspotFields
        if(!this.disableHubspot){
          axios.post('https://api.hsforms.com/submissions/v3/integration/submit/1979474/2b4d8223-0fc8-4431-9495-29d330ab1cf1',data)
          .then((response)=>{     
            let res = response.data    
            //this.$router.push({path: '/thankyou'})
            this.animation = false
            this.changeDetailsEntered(2)
            
            
            
          }).catch(error => {
            console.log(error)
          });
        }
        //END HS STUFF

    },//END submit()
    refreshData(){
      if(this.refreshedOnce)
       return;
       this.refreshedOnce=true
      this.zip = this.submitData.zip
    this.city = this.submitData.city
    this.fullName = this.submitData.name
    this.email = this.submitData.email_address
    this.phone = this.submitData.oldPhone

    },
    getCommitmentTitle(commitment){
      if(commitment==1)
        return "1+ maand";
      if(commitment==3)
        return "3+ maanden";
      if(commitment==6)
        return "6+ maanden";
      if(commitment==12)
        return "12+ maanden";
    },
    getPlan(){
      return this.submitData.plan
    },
    getPlanPrice(){
      return this.submitData.planPrice
    },
    getTotalES(){
      return this.submitData.totalES
    },
    getESPrice(){
      return this.submitData.totalESPrice
    },
    getPrefMoment(){
     return this.submitData.prefMoment
    },
    getPrefMomentPrice(){
      return this.submitData.prefMomentPrice
    },
    getPrefDate(){
      return this.submitData.prefDate
    },

  },//END methods
   
  created(){
   
    
    this.pickupDate = this.sevenDays()
    this.changeSubmitData({item:'prefDate',new:this.pickupDate})
    this.prefMoment = 0
    this.selectedSize = this.submitData.storage_size
    this.selectSize(this.selectedSize)
    this.zip = this.submitData.zip
    this.city = this.submitData.city
    this.fullName = this.submitData.name
    this.email = this.submitData.email_address
    this.phone = this.submitData.oldPhone
    

  } 

}
</script>

<style scoped>
.an {
  width: 100px;
  height: 100px;
  animation-name: example;
  position: relative;
  animation-duration: 4s;
  animation-iteration-count: infinite
}
@keyframes example {
  0%   {left:0px; top:0px;}
  
  100%  {left:800px; top:0px;}
}

</style>